import legoGrid from './legoGrid';
import legoGridIndicator from './legoGridIndicator';
import legoGridRow from './legoGridRow';
import legoGridColumn from './legoGridColumn';

export default function install(Vue) {
  Vue.component(legoGrid.name, legoGrid);
  Vue.component(legoGridIndicator.name, legoGridIndicator);
  Vue.component(legoGridRow.name, legoGridRow);
  Vue.component(legoGridColumn.name, legoGridColumn);
}
